import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FAQ } from '../data/site';
import TitreSection from './TitreSection';
import Reveal from './Reveal';

// Toutes les questions sont fermees au depart : le visiteur voit la liste
// complete d'un coup d'oeil et ouvre celle qui le concerne.
export function ListeFaq({ questions, depart = -1 }) {
  const [ouvert, setOuvert] = useState(depart);
  return (
    <div>
      {questions.map((f, i) => {
        const actif = ouvert === i;
        return (
          <Reveal key={f.q} delai={Math.min(i * 0.03, 0.2)}>
            <div className={`border-b border-nuit/12 ${actif ? 'bg-trame/60' : ''}`}>
              <h3>
                <button
                  type="button"
                  onClick={() => setOuvert(actif ? -1 : i)}
                  aria-expanded={actif}
                  className="w-full text-left flex items-start gap-4 py-5 px-3 group"
                >
                  <span
                    className={`mt-0.5 shrink-0 w-7 h-7 flex items-center justify-center rounded-[3px] transition-colors ${
                      actif ? 'bg-jaune text-nuit' : 'bg-nuit/8 text-bleu group-hover:bg-jaune group-hover:text-nuit'
                    }`}
                    aria-hidden="true"
                  >
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round">
                      <path d="M2 7h10" />
                      {!actif && <path d="M7 2v10" />}
                    </svg>
                  </span>
                  <span className="font-cond uppercase font-bold tracking-[0.02em] text-[17px] sm:text-[19px] text-nuit">
                    {f.q}
                  </span>
                </button>
              </h3>
              {actif && <div className="pb-6 pl-[52px] pr-4 text-nuit/75 max-w-2xl">{f.r}</div>}
            </div>
          </Reveal>
        );
      })}
    </div>
  );
}

export default function Faq({
  questions = FAQ.filter((f) => f.accueil),
  avant = 'Ce que les pros nous demandent ',
  mot = 'souvent',
  lienPage = true,
}) {
  return (
    <section className="bg-white py-16 sm:py-20" id="faq">
      <div className="conteneur">
        <TitreSection avant={avant} mot={mot} />
        <div className="mt-9 max-w-3xl">
          <ListeFaq questions={questions} />
          {lienPage && (
            <div className="mt-8">
              <Link to="/faq" className="btn-ligne">
                Voir toutes les questions
              </Link>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
